import styled from 'styled-components';
import { Async } from 'react-select';
import { useTranslation } from 'react-i18next';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from 'components/CustomSelect/Select';
import RegularCheckbox from 'components/Checkbox/RegularCheckbox';
import { asyncSelectStyles } from 'views/Orders/styles';
import { toast } from 'react-toastify';

import BoxSection from '../BoxSection';
import OrderSummarySection from '../OrderSummarySection/OrderSummarySection';
import CustomerInvoiceSection from '../CustomerInvoiceSection/CustomerInvoiceSection';

const SummarySectionWrapper = styled.div`
  width: 100%;
  display: flex;
  margin: 0 -5px;
  flex-flow: column;
  justify-content: space-between;

  @media (min-width: 769px) {
    flex-flow: row;
  }
`;

const SummarySection = ({
  diets,
  classes,
  orderCost,
  promoCode,
  paymentType,
  useMoneyBox,
  usePromoCode,
  paymentMethods,
  setUseMoneyBox,
  setUsePromoCode,
  selectPromoCode,
  sendConfirmation,
  promisePromoCodes,
  selectPaymentType,
  isInvoiceIncluded,
  setSendConfirmation,
  customerInvoiceData,
  setIsInvoiceIncluded,
  setCustomerInvoiceData,
}) => {
  const { t } = useTranslation();

  return (
    <SummarySectionWrapper>
      <BoxSection
        title={t('orders.additionalOptions', '$$Opcje dodatkowe')}
        style={{ margin: '5px' }}
      >
        <div
          style={{ width: '100%' }}
          data-cy="new-order_additional-option_send-confirm"
        >
          <FormControlLabel
            control={
              <RegularCheckbox
                name="active"
                checked={sendConfirmation}
                // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
                onClick={e => {
                  setSendConfirmation(prev => !prev);
                }}
              />
            }
            label={t(
              'orders.sendClientNotify',
              '$$Wyślij potwierdzenie do klienta'
            )}
          />
        </div>
        <div
          style={{ width: '100%' }}
          data-cy="new-order_additional-option_discount-code"
        >
          <FormControlLabel
            control={
              <RegularCheckbox
                name="active"
                checked={usePromoCode}
                onClick={() => {
                  setUsePromoCode(!usePromoCode);
                }}
              />
            }
            label={t(
              'orders.newOrder.SummarySection.discountCode',
              'Użyj kodu rabatowego'
            )}
          />
          {usePromoCode && (
            <>
              <Async
                styles={asyncSelectStyles}
                isClearable={true}
                loadOptions={promisePromoCodes}
                onChange={code => {
                  if (code?.value?.diets.length > 0) {
                    const array = [];
                    code?.value?.diets.map(el =>
                      array.push(el === diets?.[0].selectedDiet.value)
                    );
                    // eslint-disable-next-line no-empty -- FIXME
                    if (array.includes(true)) {
                    } else {
                      return toast.error(t('orders.discountCodeExclude'));
                    }
                  }

                  return selectPromoCode(code);
                }}
                value={promoCode}
                placeholder={t('orders.discountCode', '$$Kod rabatowy')}
                clearValue={() => selectPromoCode(null)}
                noOptionsMessage={() => t('orders.discountCodeContent')}
              />
            </>
          )}
        </div>
        <div
          style={{ width: '100%' }}
          data-cy="new-order_additional-option_piggy-bank-points"
        >
          <FormControlLabel
            control={
              <RegularCheckbox
                name="active"
                checked={useMoneyBox}
                // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
                onClick={e => {
                  setUseMoneyBox(!useMoneyBox);
                }}
              />
            }
            label={t(
              'orders.useMoneyboxPoints',
              '$$Wykorzystaj punkty ze skarbonki'
            )}
          />
        </div>
        <div
          style={{ width: '100%' }}
          data-cy="new-order_additional-option_issue-invoice"
        >
          <FormControlLabel
            control={
              <RegularCheckbox
                name="active"
                checked={isInvoiceIncluded}
                onClick={() => {
                  setIsInvoiceIncluded(!isInvoiceIncluded);
                }}
              />
            }
            label={t('orders.makeInvoice', '$$Wystaw fakturę')}
          />
          {isInvoiceIncluded && (
            <CustomerInvoiceSection
              classes={classes}
              customerInvoiceData={customerInvoiceData}
              setCustomerInvoiceData={setCustomerInvoiceData}
            />
          )}
        </div>
      </BoxSection>
      <BoxSection
        title={t('orders.paymentSection', '$$Płatność')}
        style={{ margin: '5px' }}
      >
        <div style={{ marginTop: '15px' }} data-cy="new-order_payment-types">
          <Select
            classes={classes}
            mapBy="label"
            trackBy="value"
            label={t('orders.select', '$$Wybierz')}
            value={paymentType}
            options={paymentMethods}
            handleChange={option => {
              selectPaymentType(option);
            }}
          />
        </div>
      </BoxSection>
      <OrderSummarySection
        diets={diets}
        orderCost={orderCost}
        useMoneyBox={useMoneyBox}
      />
    </SummarySectionWrapper>
  );
};

export default SummarySection;
